import { render, staticRenderFns } from "./TimelineItem.vue?vue&type=template&id=b2839688&scoped=true"
import script from "./TimelineItem.vue?vue&type=script&lang=js"
export * from "./TimelineItem.vue?vue&type=script&lang=js"
import style0 from "./TimelineItem.vue?vue&type=style&index=0&id=b2839688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2839688",
  null
  
)

export default component.exports